<div class="navbar navbar-fixed-top">
  <app-weblink-header (onChangeUser)="changeUser()"></app-weblink-header>
  <!-- <div class="container-fluid docma-bg-dark-medium docma-c-white pad-it">
    <div class="row text-nowrap max-width">
      <span>{{ 'weblink.misc.project' | translate }}: {{data?.Project?.Name1}} - {{data?.Project?.Name2}}</span>
    </div>
    <div class="row text-nowrap max-width">
      <span class="hint">
        {{ 'weblink.misc.title' | translate }} {{tokenValidity}} ({{openFaults}}/{{count}})
      </span>
    </div>
    <div class="row" *ngIf="data?.Company">
        <div class="col-md-1 col-xs-2">{{ 'weblink.misc.company' | translate }}:</div>
        <div class="col-md-11 col-xs-10">{{data.Company.Name1}}</div>
    </div>
  </div> -->

  <div class="row docma-bg-dark-medium docma-c-white splitter-horizontal max-width pad-it">
      <div class="col-xs-3 no-horizontal-padding">
        <input type="checkbox" [checked]="allSelected" [disabled]="isInEditMode || isLoading" (change)="allSelected = !allSelected" [style.marginLeft]="'4px'"/>
        <button class="btn btn-primary docma-bg-purple docma-c-white margin-left" [disabled]="!faultsSelected" (click)="clickEdit();">
          <span class="glyphicon glyphicon-pencil"></span>
          <span class="hidden-xs">{{ 'weblink.button.edit' | translate }}</span>
        </button>
      </div>
      <div class="col-xs-4 no-horizontal-padding">
        <input type="text" #search class="form-control no-right-border-radius" (keyup)="searchFault(search.value);" placeholder="suchen" [(ngModel)]="searchValue"/>
      </div>
      <div *ngIf="!search.value" class="col-xs-2 no-horizontal-padding">
        <button #refreshFaults class="btn btn-primary no-left-border-radius">
          <span class="glyphicon glyphicon-search"></span>
        </button>
      </div>
      <div *ngIf="search.value" class="col-xs-2 no-horizontal-padding">
        <button #refreshFaults class="btn btn-primary no-left-border-radius" (click)="search.value=null;searchFault(search.value);">
          <span class="glyphicon glyphicon-remove"></span>
        </button>
      </div>
      <div class="col-xs-3">
        <button #resync class="btn btn-primary docma-bg-purple docma-c-white floating" (click)="sync();" *ngIf="hasErrorFaults"><span class="glyphicon glyphicon-floppy-open"></span>
          <span class="hidden-xs"> {{ 'weblink.button.resync' | translate }}</span>
        </button>
        <button #refreshFaults class="btn btn-primary floating" (click)="refresh();" [disabled]="isLoading||isInEditMode" *ngIf="!hasErrorFaults">
          <span class="glyphicon glyphicon-refresh"></span>
          <span class="hidden-xs"> {{ 'weblink.button.refresh' | translate }}</span>
        </button>
      </div>
  </div>

</div>

<div class="container-fluid offset-xs max-width" *ngIf="this.errorMessage" [style.backgroundColor]="'red'" [style.color]="'white'">
  <button class="pull-right" (click)="this.errorMessage=null;">X</button>
  <b>{{this.errorMessage}}</b>
</div>

<div class="container-fluid docma-bg-dark-light-2 docma-c-dark-grey pad-it offset-xs">
  <div class="row text-nowrap max-width">
    <span>{{ 'weblink.misc.project' | translate }}: {{data?.Project?.Name1}} - {{data?.Project?.Name2}}</span>
  </div>
  <div class="row max-width">
    <span class="hint">
      {{ 'weblink.misc.title' | translate }} {{tokenValidity}} ({{openFaults}}/{{count}})
    </span>
  </div>
  <div class="row" *ngIf="data?.Company">
      <div class="col-md-1 col-xs-2">{{ 'weblink.misc.company' | translate }}:</div>
      <div class="col-md-11 col-xs-10">{{data.Company.Name1}}</div>
  </div>
</div>

<div class="container-fluid" *ngIf="!!this.faults">
  <div *ngFor="let fault of faults" class="row">
    <!-- <app-weblink-fault-tile *ngIf="!fault.filter" [fault]="fault" [status]="data.Status" [layout]="layout" [fields]="data.Fields" (checkChanged)="faultCheckChanged($event)" (editFault)="editFault(fault);"></app-weblink-fault-tile> -->
    <app-weblink-fault-detail *ngIf="!fault.filter" [fault]="fault" [settings]="settings" [status]="data.Status" [layout]="layout" [fields]="data.Fields" (checkChanged)="faultCheckChanged($event)" (showLastActivity)="showLastActivity(fault)"  (editFault)="editFault(fault, settings);" (attachmentClick)="attachmentClick($event)" ></app-weblink-fault-detail>
  </div>
</div>

<app-weblink-fault-edit *ngIf="isInEditMode" [faults]="selectedFaults" [settings]="settings" [status]="data?.Status" (cancelDialog)="isInEditMode=false;" (closeDialog)="isInEditMode=false; saveFaults();"></app-weblink-fault-edit>

<app-weblink-activity-view *ngIf="isInViewMode" [activity]="selectedActivity"  (closeDialog)="isInViewMode=false"></app-weblink-activity-view>

<app-weblink-loader *ngIf="isLoading"></app-weblink-loader>

<app-weblink-attachment-list [modal]="true" ></app-weblink-attachment-list>
